module.exports = __webpack_public_path__ + "static/woodenbrush-7ce5fda15d4162abe0699438f1fca592.jpeg";